import { ProductCoverSkeletonRow, ProductCoverSkeletonWrapper } from '../../styled'
import React from 'react'
import { useWindowSize } from 'hooks'
import Skeleton from 'react-loading-skeleton'

const CoverLoading: React.FC<{ symbol: string }> = ({ symbol }) => {
  const { isDesktop, isTablet, isMobile } = useWindowSize()
  const isApy = symbol !== 'artxai' && symbol !== 'jmx'

  return (
    <ProductCoverSkeletonWrapper>
      <Skeleton height={!isMobile ? 112 : 93} borderRadius="1.5rem" />
      <Skeleton
        height={!isMobile ? 112 : 93}
        width={isTablet ? 300 : isDesktop ? 360 : '100%'}
        borderRadius="1.5rem"
      />
      {isMobile && <Skeleton height={93} borderRadius="1.5rem" />}
      <ProductCoverSkeletonRow isApy={isApy}>
        <Skeleton
          height={isMobile || (isApy && isTablet) ? 55 : 75}
          width={isMobile || (isApy && isTablet) ? 55 : 75}
          borderRadius="1.5rem"
        />
        <Skeleton
          height={isMobile || (isApy && isTablet) ? 55 : 75}
          width={isMobile || (isApy && isTablet) ? 55 : 75}
          borderRadius="1.5rem"
        />
        <Skeleton
          height={isMobile || (isApy && isTablet) ? 55 : 75}
          width={isMobile || (isApy && isTablet) ? 55 : 75}
          borderRadius="1.5rem"
        />
        {isApy && (
          <Skeleton
            height={isDesktop ? 75 : 55}
            width={isDesktop ? 75 : 55}
            borderRadius="1.5rem"
          />
        )}
      </ProductCoverSkeletonRow>
    </ProductCoverSkeletonWrapper>
  )
}
export default CoverLoading
